import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

import SuccessHandler from '../SuccessHandler'

/* private BrandConfiguration Types */
import {
  Settings,
  _BrandConfiguration
} from '../namespace-helper'

import _ from 'lodash'

const selectedBrandConfigurationTemplate = {
  id: 0,
  name: '',
  default: false
}

export default {
  namespaced: true,
  state: {
    brandConfigurations: [],
    allBrandConfigurations: [],
    selectedBrandConfiguration: _.cloneDeep(selectedBrandConfigurationTemplate),
    openDialog: false
  },
  mutations: {
    [_BrandConfiguration.mutations.setBrandConfigurations] (state, payload) {
      state.brandConfigurations = payload
    },
    [_BrandConfiguration.mutations.setAllBrandConfigurations] (state, payload) {
      state.allBrandConfigurations = payload
    },
    [_BrandConfiguration.mutations.setSelectedBrandConfiguration] (state, payload) {
      if (payload !== null) {
        state.selectedBrandConfiguration = payload
      } else {
        state.selectedBrandConfiguration = _.cloneDeep(selectedBrandConfigurationTemplate)
      }
    },
    [_BrandConfiguration.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_BrandConfiguration.actions.saveBrandConfiguration] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/brandConfigurations'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
            context.commit(_BrandConfiguration.mutations.setSelectedBrandConfiguration, r.data.data)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/brandConfigurations/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
            context.commit(_BrandConfiguration.mutations.setSelectedBrandConfiguration, r.data.data)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_BrandConfiguration.actions.loadBrandConfigurations] (context, payload) {
      console.log('loadBrandConfigurations: ' + JSON.stringify(payload))
      console.log('loadBrandConfigurations: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/brandConfigurations?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;name:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfiguration.mutations.setBrandConfigurations, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfiguration.actions.loadAllBrandConfigurations] (context, payload) {
      var url = API_URL + '/api/v1/brandConfigurations'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfiguration.mutations.setAllBrandConfigurations, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfiguration.actions.openCloseDialog] ({ commit }) {
      commit(_BrandConfiguration.mutations.setOpenCloseDialogState)
    },
    [_BrandConfiguration.actions.setSelectedBrandConfiguration] ({ commit }, payload) {
      commit(_BrandConfiguration.mutations.setSelectedBrandConfiguration, payload)
    },
    [_BrandConfiguration.actions.resetState] ({ commit }, payload) {
      commit(_BrandConfiguration.mutations.setBrandConfigurations, [])
      commit(_BrandConfiguration.mutations.setAllBrandConfigurations, [])
      commit(_BrandConfiguration.mutations.setSelectedBrandConfiguration, null)
    }
  },
  getters: {
    [_BrandConfiguration.getters.brandConfigurations] (state) {
      return state.brandConfigurations
    },
    [_BrandConfiguration.getters.getAllBrandConfigurations] (state) {
      return state.allBrandConfigurations
    },
    [_BrandConfiguration.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_BrandConfiguration.getters.getSelectedBrandConfiguration] (state) {
      return state.selectedBrandConfiguration
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/BrandConfiguration/brandConfigurations.js